import * as Api from "@api";
import React from "react";
import SuggestedSproutSetting from "@/parts/TipsTricksSection/SuggestedSproutSetting";

interface ISuggestedSproutSettingBoxProps
{
    boxName: string;
    pageContent: Record<string, Api.ContentItem>;
    imageDirectory: string;
}

const SuggestedSproutSettingBox = ({ boxName, pageContent, imageDirectory }: ISuggestedSproutSettingBoxProps) => {
    return <div className="md:bg-[#EEE8E2] md:p-10 rounded-[12px] text-center flex flex-col gap-10 justify-between">
        <div className='space-y-2.5'>
            <h5 className='font-semibold'>
                {pageContent[`sense.sprout-battery.suggested-settings.${boxName}.headline`]?.data}</h5>
            <p className='italic text-[#F12C01]'>
                {pageContent[`sense.sprout-battery.suggested-settings.${boxName}.hint`]?.data}</p>
            <p>
                {pageContent[`sense.sprout-battery.suggested-settings.${boxName}.body`]?.data}</p>
        </div>
        <div className='space-y-10'>
            {
                ['voltage', 'activepulse', 'wattage'].map(settingName => (
                    <SuggestedSproutSetting
                        key={`${settingName}-${boxName}`}
                        settingName={settingName as 'voltage' | 'activepulse' | 'wattage'}
                        boxName={boxName}
                        imageDirectory={imageDirectory}
                    />
                ))
            }
        </div>
    </div>
}

export default SuggestedSproutSettingBox;
